import { useEffect, useState } from "react";
import {
	IOrderListRequest,
	IOrderSummary,
	OrderFilterModel,
} from "../app/models/IOrder";
import { faker } from "@faker-js/faker";
import { getOrders } from "../app/services/manager/admin/orders.service";

export const useOrderList = (withFilters: OrderFilterModel) => {
	const [listIsLoading, setListIsLoading] = useState(false);
	const [orderList, setOrderList] = useState<IOrderListRequest>();

	useEffect(() => {
		loadOrderList();
	}, [withFilters]);

	const loadOrderList = () => {
		setListIsLoading(true);

		getOrders(withFilters)
			.then((response) => {
				setOrderList(response);
			})
			.finally(() => {
				setListIsLoading(false);
			});
	};

	return { listIsLoading, orderList, loadOrderList };
};

const mockOrderList = (): IOrderListRequest => {
	let nItems = faker.datatype.number(24);
	let orders: IOrderSummary[] = [];

	for (let i = 0; i < nItems; i++) {
		orders.push(mockOrderSummary());
	}

	return {
		count: nItems,
		next: "",
		previous: "",
		results: orders,
	};
};

const mockOrderSummary = (): IOrderSummary => {
	return {
		id: faker.datatype.number(),
		order_name: faker.datatype.number() + " - " + faker.name.fullName(),
		created_at: faker.date.recent(),
		amount: faker.datatype.number({ min: 1000, max: 100000 }),
		payment_type: 1,
		order_status: 1,
		payment_status: 1,
		boleto_url: "",
		total_items: faker.datatype.number(20),
		order_status_display: faker.helpers.arrayElement([
			"OPEN",
			"PROCESSING",
			"CLOSED",
			"CANCELED",
		]),
		payment_status_display: faker.helpers.arrayElement([
			"WAITING_PAYMENT",
			"PAID",
			"REFUSED",
		]),
		invoice: "",
		payment_type_display: faker.helpers.arrayElement([
			"CREDIT CARD",
			"BOLETO",
		]),
	};
};
